import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

export function getColumns(columnsConditions = {}) {
  const columns = prepareColumns();

  return columns.filter((item) => {
    // eslint-disable-next-line no-prototype-builtins
    if (columnsConditions.hasOwnProperty(item.name)) {
      return columnsConditions[item.name];
    }
    return true;
  });
}

export function prepareColumns() {
  return [
    {
      name: 'sector',
      title: 'Sector',
      sortable: true,
      className: alignStyles.alignLeft,
      width: 70,
    },
    {
      name: 'name',
      title: 'Bond',
      sortable: true,
      className: alignStyles.alignLeft,
    },
    {
      name: 'tradeSize',
      title: 'Trade size ($)',
      sortable: true,
      className: alignStyles.alignRight,
      width: 111,
    },
    {
      name: 'price',
      title: 'Price ($)',
      sortable: true,
      className: alignStyles.alignRight,
      width: 94,
    },
    {
      name: 'coupon',
      title: 'Coupon',
      sortable: true,
      className: alignStyles.alignRight,
      width: 78,
    },
    {
      name: 'maturityDate',
      title: 'Maturity',
      sortable: true,
      className: alignStyles.alignRight,
      width: 101,
    },
    {
      name: 'factor',
      title: 'Factor',
      sortable: true,
      className: alignStyles.alignRight,
      width: 74,
    },
    {
      name: 'remuneration',
      title: 'RMUN',
      sortable: true,
      className: alignStyles.alignCenter,
      width: 65,
      tooltipContent: 'Remuneration',
    },
    {
      name: 'tradeStatus',
      title: 'Status',
      sortable: true,
      className: alignStyles.alignCenter,
      width: 94,
    },
    {
      name: 'reportingPartyType',
      title: 'RPT',
      sortable: true,
      className: alignStyles.alignCenter,
      width: 82,
      tooltipContent: 'Reporting Party Type',
    },
    {
      name: 'reportingPartySide',
      title: 'Side',
      sortable: true,
      className: alignStyles.alignRight,
      width: 70,
      tooltipContent: 'Reporting Party Side',
    },
    {
      name: 'contraPartyType',
      title: 'CPT',
      sortable: true,
      className: alignStyles.alignRight,
      width: 88,
      tooltipContent: 'Contra Party Type',
    },
    {
      name: 'tradeDate',
      title: 'Trade timestamp ET',
      sortable: true,
      className: alignStyles.alignRight,
      width: 160,
      minWidth: 160,
    },
  ];
}
